import React from 'react';
import { ArrowLeftIcon, CheckCircleIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { RestaurantProfitCalculator } from '../components/RestaurantProfitCalculator';
import { LogoCarousel } from '../components/LogoCarousel';
export function RestaurantsPage() {
  return <div className="min-h-screen bg-white" data-id="element-513">
      {/* Header */}
      <div className="py-20 md:py-32" style={{
      backgroundColor: '#1a2332'
    }} data-id="element-514">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-515">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white mb-8 transition-colors" data-id="element-516">
            <ArrowLeftIcon size={16} data-id="element-517" />
            Back to Home
          </Link>
          <h1 className="text-4xl md:text-7xl font-light mb-6 text-white" data-id="element-518">
            WELLHAUS™
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-light max-w-3xl mb-8" data-id="element-519">
            Premium Water, Elevated Experience
          </p>
          <p className="text-lg text-gray-400 max-w-3xl mb-8" data-id="element-520">
            Still Alkaline • Sparkling Mineral (Pellegrino-Style) • Hot Alkaline
          </p>
          <p className="text-base text-gray-300 max-w-3xl mb-10" data-id="element-521">
            WELLHAUS™ delivers unmatched purity, modern design, and
            industry-first water technology for restaurants, hotels, cafés,
            spas, and corporate environments.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-522">
            <a href="https://form.jotform.com/260365019039051" target="_blank" rel="noopener noreferrer" className="px-10 py-4 bg-white text-gray-900 text-base font-medium rounded-full hover:bg-gray-100 transition-colors text-center" data-id="element-523">
              Apply Here
            </a>
            <a href="https://form.typeform.com/to/rfYM00cT" target="_blank" rel="noopener noreferrer" className="px-10 py-4 bg-white text-gray-900 text-base font-medium rounded-full hover:bg-gray-100 transition-colors text-center" data-id="element-524">
              Request a Demo
            </a>
            <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="px-10 py-4 border border-white text-white text-base font-medium rounded-full hover:bg-white hover:text-gray-900 transition-colors text-center" data-id="element-525">
              Contact Sales
            </a>
          </div>
        </div>
      </div>

      {/* Hero Image */}
      <div className="relative h-[400px] md:h-[600px]" data-id="element-526">
        <img src="https://cdn.magicpatterns.com/uploads/kZhkMRPEbMaCr8wQW33oKv/Wellhaus_Restaurant_.webp" alt="WELLHAUS Drinkstation in fine dining restaurant" className="w-full h-full object-cover" data-id="element-527" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-528" />
      </div>

      {/* Logo Carousel */}
      <LogoCarousel data-id="element-529" />

      {/* Why WELLHAUS Section */}
      <div className="py-20 md:py-32 bg-white" data-id="element-530">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-531">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-532">
            <h2 className="text-4xl md:text-6xl font-light mb-6" data-id="element-533">
              Why WELLHAUS™
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-534">
              WELLHAUS is built for venues that demand the highest standards in
              water quality, culinary performance, guest experience, and
              sustainability.
            </p>
          </div>
        </div>
      </div>

      {/* Exclusive Smart Soda Advantages */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-535">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-536">
          <div className="max-w-4xl mx-auto" data-id="element-537">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-538">
              Exclusive WELLHAUS™ Advantages
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12" data-id="element-539">
              WELLHAUS™ is the ONLY company that offers:
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-540">
              <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-541">
                <h3 className="text-2xl font-light mb-4" data-id="element-542">
                  Still Alkaline Water
                </h3>
                <p className="text-gray-600" data-id="element-543">
                  Pure, balanced pH for everyday wellbeing and superior taste.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-544">
                <h3 className="text-2xl font-light mb-4" data-id="element-545">
                  Sparkling Mineral Water
                </h3>
                <p className="text-gray-600" data-id="element-546">
                  Pellegrino-style sparkling mineral water, uniquely made from
                  alkaline water.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-547">
                <h3 className="text-2xl font-light mb-4" data-id="element-548">
                  Ambient Alkaline Water
                </h3>
                <p className="text-gray-600" data-id="element-549">
                  Room temperature alkaline water for culinary applications.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-550">
                <h3 className="text-2xl font-light mb-4" data-id="element-551">
                  Custom-Branded Bottle Printing
                </h3>
                <p className="text-gray-600" data-id="element-552">
                  Full custom bottle printing for your brand identity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Sparkling Mineral Water Matters */}
      <div className="py-20 md:py-32 bg-white" data-id="element-553">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-554">
          <div className="max-w-4xl mx-auto" data-id="element-555">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-556">
              <div data-id="element-557">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-558">
                  Why Sparkling Mineral Water Matters
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-559">
                  WELLHAUS™'s Sparkling Mineral Water is made from alkaline
                  water — not acidic RO water.
                </p>
                <div className="space-y-4 mb-6" data-id="element-560">
                  <div className="flex items-start gap-3" data-id="element-561">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-562" />
                    <div data-id="element-563">
                      <p className="font-medium text-gray-900" data-id="element-564">Less Acidic</p>
                      <p className="text-sm text-gray-600" data-id="element-565">
                        Gentler on the palate and digestive system
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-566">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-567" />
                    <div data-id="element-568">
                      <p className="font-medium text-gray-900" data-id="element-569">Silkier</p>
                      <p className="text-sm text-gray-600" data-id="element-570">
                        Smoother mouthfeel and texture
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-571">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-572" />
                    <div data-id="element-573">
                      <p className="font-medium text-gray-900" data-id="element-574">Healthier</p>
                      <p className="text-sm text-gray-600" data-id="element-575">
                        Balanced pH supports overall wellness
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-576">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-577" />
                    <div data-id="element-578">
                      <p className="font-medium text-gray-900" data-id="element-579">
                        Fresher and Cleaner
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-580">
                        On-demand production ensures peak freshness
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-base text-gray-700 italic" data-id="element-581">
                  Taste profile similar to Pellegrino/Acqua Panna, but cleaner.
                  No competitor can replicate this.
                </p>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-582">
                <img src="https://cdn.magicpatterns.com/uploads/rQWcL2dcjXTY7LtHPtBanm/WATER-VINCI-v2-2025-01.931_(1).webp" alt="WELLHAUS Drinkstation control panel" className="w-full h-full object-cover" data-id="element-583" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Perfect For */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-584">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-585">
          <div className="max-w-4xl mx-auto" data-id="element-586">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-587">
              Perfect For
            </h2>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-588">
              <div className="bg-white p-6 rounded-xl" data-id="element-589">
                <p className="text-lg text-gray-700" data-id="element-590">
                  Premium restaurants & cafés
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-591">
                <p className="text-lg text-gray-700" data-id="element-592">
                  Hotels, resorts, lounges & spas
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-593">
                <p className="text-lg text-gray-700" data-id="element-594">
                  Corporate dining & conference centers
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-595">
                <p className="text-lg text-gray-700" data-id="element-596">
                  Co-working & hospitality suites
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-597">
                <p className="text-lg text-gray-700" data-id="element-598">Wellness clubs</p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-599">
                <p className="text-lg text-gray-700" data-id="element-600">Bars & event spaces</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Culinary & Beverage Advantages */}
      <div className="py-20 md:py-32 bg-white" data-id="element-601">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-602">
          <div className="max-w-4xl mx-auto" data-id="element-603">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-604">
              Culinary & Beverage Advantages
            </h2>

            <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-605">
              <div data-id="element-606">
                <h3 className="text-2xl font-light mb-6" data-id="element-607">
                  Back-of-House (Culinary)
                </h3>
                <ul className="space-y-3 text-gray-700" data-id="element-608">
                  <li className="flex items-start gap-3" data-id="element-609">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-610" />
                    <span data-id="element-611">Cooking, baking, doughs, breads, pasta</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-612">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-613" />
                    <span data-id="element-614">Soups, sauces, reductions</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-615">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-616" />
                    <span data-id="element-617">
                      Coffee & espresso (better extraction, less acidity)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-618">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-619" />
                    <span data-id="element-620">Tea & infusions</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-621">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-622" />
                    <span data-id="element-623">Ice machines — clearer, harder ice</span>
                  </li>
                </ul>
              </div>

              <div data-id="element-624">
                <h3 className="text-2xl font-light mb-6" data-id="element-625">Front-of-House</h3>
                <ul className="space-y-3 text-gray-700" data-id="element-626">
                  <li className="flex items-start gap-3" data-id="element-627">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-628" />
                    <span data-id="element-629">Still, Sparkling & Sparkling Mineral</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-630">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-631" />
                    <span data-id="element-632">Alkaline water service</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-633">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-634" />
                    <span data-id="element-635">
                      Menu integration ("Still • Sparkling • Sparkling Mineral •
                      Alkaline")
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-636">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-637" />
                    <span data-id="element-638">Custom-branded bottle service</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-639">
              <img src="https://cdn.magicpatterns.com/uploads/iKwAGq8krtX1SRnrGw74t4/Culinary__Beverage_Advantages.webp" alt="WELLHAUS Drinkstation in fine dining restaurant" className="w-full h-full object-cover" data-id="element-640" />
            </div>
          </div>
        </div>
      </div>

      {/* Custom Bottle Printing */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-641">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-642">
          <div className="max-w-4xl mx-auto" data-id="element-643">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-644">
              <div className="order-2 md:order-1 relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-645">
                <img src="https://cdn.magicpatterns.com/uploads/wvpp54LGRTQnDaudMGriSh/Bottle.webp" alt="Custom branded WELLHAUS bottle" className="w-full h-full object-cover" data-id="element-646" />
              </div>
              <div className="order-1 md:order-2" data-id="element-647">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-648">
                  Custom Bottle Printing
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-649">
                  Exclusive full custom bottle printing:
                </p>
                <ul className="space-y-3 text-gray-700 mb-6" data-id="element-650">
                  <li className="flex items-start gap-3" data-id="element-651">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-652" />
                    <span data-id="element-653">Reusable/glass bottles</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-654">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-655" />
                    <span data-id="element-656">Restaurant, hotel, VIP, and event branding</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-657">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-658" />
                    <span data-id="element-659">Wellness-themed designs</span>
                  </li>
                </ul>
                <p className="text-base text-gray-700 font-medium" data-id="element-660">
                  Benefits: higher check averages, luxury presentation,
                  eco-friendly service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Technology & Performance */}
      <div className="py-20 md:py-32 bg-white" data-id="element-661">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-662">
          <div className="max-w-4xl mx-auto" data-id="element-663">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-664">
              Technology & Performance
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-665">
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-666">
                <p className="text-gray-700" data-id="element-667">Multi-stage advanced filtration</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-668">
                <p className="text-gray-700" data-id="element-669">
                  Stainless steel internal architecture
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-670">
                <p className="text-gray-700" data-id="element-671">High-capacity chilling</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-672">
                <p className="text-gray-700" data-id="element-673">AI diagnostics</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-674">
                <p className="text-gray-700" data-id="element-675">Automatic cleaning cycles</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-676">
                <p className="text-gray-700" data-id="element-677">
                  Consistent carbonation & mineral dosing
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-678">
                <p className="text-gray-700" data-id="element-679">110V standard</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-680">
                <p className="text-gray-700" data-id="element-681">Countertop models</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-682">
                <p className="text-gray-700" data-id="element-683">
                  Under-counter & free-standing options
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sustainability */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-684">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-685">
          <div className="max-w-4xl mx-auto" data-id="element-686">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-687">
              <div data-id="element-688">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-689">
                  Sustainability
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-690">
                  WELLHAUS reduces:
                </p>
                <ul className="space-y-3 text-gray-700 mb-6" data-id="element-691">
                  <li className="flex items-start gap-3" data-id="element-692">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-693" />
                    <span data-id="element-694">Plastic bottles</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-695">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-696" />
                    <span data-id="element-697">Pallet deliveries</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-698">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-699" />
                    <span data-id="element-700">Cold storage</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-701">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-702" />
                    <span data-id="element-703">Recycling waste</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-704">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-705" />
                    <span data-id="element-706">Carbon footprint</span>
                  </li>
                </ul>
                <p className="text-xl text-gray-900 font-medium" data-id="element-707">
                  Up to 90% plastic reduction per location.
                </p>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-708">
                <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800&q=80" alt="Sustainability" className="w-full h-full object-cover" data-id="element-709" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing */}
      <div className="py-20 md:py-32 bg-white" data-id="element-710">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-711">
          <div className="max-w-4xl mx-auto" data-id="element-712">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-713">
              WELLHAUS™ Subscription Pricing
            </h2>

            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 text-white mb-8" data-id="element-714">
              <div className="text-center mb-8" data-id="element-715">
                <p className="text-5xl md:text-6xl font-light mb-2" data-id="element-716">
                  $299 <span className="text-2xl text-gray-300" data-id="element-717">USD</span> /
                  $399 <span className="text-2xl text-gray-300" data-id="element-718">CAD</span>
                </p>
                <p className="text-lg text-gray-300" data-id="element-719">per month</p>
              </div>

              <div className="space-y-4" data-id="element-720">
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-721">
                  <span className="text-gray-200" data-id="element-722">The WELLHAUS™ System</span>
                  <span className="text-white font-medium" data-id="element-723">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-724">
                  <span className="text-gray-200" data-id="element-725">Installation & Delivery</span>
                  <span className="text-white font-medium" data-id="element-726">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-727">
                  <span className="text-gray-200" data-id="element-728">Lease to Own</span>
                  <span className="text-white font-medium" data-id="element-729">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-730">
                  <span className="text-gray-200" data-id="element-731">$0 Down Payment</span>
                  <span className="text-white font-medium" data-id="element-732">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-733">
                  <span className="text-gray-200" data-id="element-734">
                    Unlimited Alkaline Water
                  </span>
                  <span className="text-white font-medium" data-id="element-735">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-736">
                  <span className="text-gray-200" data-id="element-737">
                    120 Customized 1L Bottles
                  </span>
                  <span className="text-white font-medium" data-id="element-738">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-739">
                  <span className="text-gray-200" data-id="element-740">Service & Maintenance</span>
                  <span className="text-white font-medium" data-id="element-741">Included</span>
                </div>
                <div className="flex items-center justify-between py-3" data-id="element-742">
                  <span className="text-gray-200" data-id="element-743">
                    Listing on the WELLHAUS™ App
                  </span>
                  <span className="text-white font-medium" data-id="element-744">Included</span>
                </div>
              </div>
            </div>

            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 mb-6" data-id="element-745">
              <div className="flex items-start gap-3" data-id="element-746">
                <span className="text-green-600 text-xl" data-id="element-747">✔</span>
                <div data-id="element-748">
                  <p className="font-medium text-gray-900 mb-1" data-id="element-749">
                    Tax Advantage
                  </p>
                  <p className="text-sm text-gray-700" data-id="element-750">
                    Eligible for IRS Section 179 — up to 100% deductible in the
                    year of use
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-6" data-id="element-751">
              <div className="flex items-start gap-3" data-id="element-752">
                <span className="text-gray-600 text-xl" data-id="element-753">✔</span>
                <div data-id="element-754">
                  <p className="font-medium text-gray-900 mb-1" data-id="element-755">Disclaimer</p>
                  <p className="text-sm text-gray-600" data-id="element-756">
                    Pricing subject to credit approval, availability, and
                    applicable tax laws.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* IRS Section 179 Benefit */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-757">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-758">
          <div className="max-w-4xl mx-auto" data-id="element-759">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-760">
              IRS Section 179 Benefit
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12" data-id="element-761">
              WELLHAUS leases are 100% Section 179 deductible.
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-762">
              <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-763">
                <h3 className="text-xl font-medium mb-3" data-id="element-764">
                  Lower Taxable Income
                </h3>
                <p className="text-gray-600" data-id="element-765">
                  Deduct the full lease amount from your taxable income
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-766">
                <h3 className="text-xl font-medium mb-3" data-id="element-767">Better Cash Flow</h3>
                <p className="text-gray-600" data-id="element-768">
                  Preserve capital while upgrading equipment
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-769">
                <h3 className="text-xl font-medium mb-3" data-id="element-770">
                  Reduced Cost of Ownership
                </h3>
                <p className="text-gray-600" data-id="element-771">
                  Tax benefits lower your effective monthly cost
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-772">
                <h3 className="text-xl font-medium mb-3" data-id="element-773">Faster ROI</h3>
                <p className="text-gray-600" data-id="element-774">
                  Tax savings accelerate return on investment
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Competitive Comparison Table */}
      <div className="py-20 md:py-32 bg-white" data-id="element-775">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-776">
          <div className="max-w-5xl mx-auto" data-id="element-777">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-778">
              Competitive Comparison
            </h2>

            <div className="overflow-x-auto" data-id="element-779">
              <table className="w-full border-collapse" data-id="element-780">
                <thead data-id="element-781">
                  <tr className="bg-gray-900 text-white" data-id="element-782">
                    <th className="text-left p-4 font-medium text-base" data-id="element-783">
                      Feature
                    </th>
                    <th className="text-center p-4 font-medium text-base" data-id="element-784">
                      WELLHAUS™
                    </th>
                    <th className="text-center p-4 font-medium text-base" data-id="element-785">
                      Competitors
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-786">
                  <tr className="border-b border-gray-200" data-id="element-787">
                    <td className="p-4 text-base text-gray-900" data-id="element-788">
                      Alkaline Water
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-789">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-790" />{' '}
                      <span className="text-base text-water-accent" data-id="element-791">
                        Exclusive
                      </span>
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-792">
                      Regular/Acidic
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-793">
                    <td className="p-4 text-base text-gray-900" data-id="element-794">
                      Sparkling Mineral (Pellegrino-Style)
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-795">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-796" />{' '}
                      <span className="text-base text-water-accent" data-id="element-797">
                        Exclusive
                      </span>
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-798">
                      Regular/Acidic
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-799">
                    <td className="p-4 text-base text-gray-900" data-id="element-800">
                      Health Profile
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-801">
                      Low-acidity
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-802">
                      High acidity
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-803">
                    <td className="p-4 text-base text-gray-900" data-id="element-804">
                      Custom Bottle Printing
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-805">
                      Yes/No cost
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-806">
                      Limited
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-807">
                    <td className="p-4 text-base text-gray-900" data-id="element-808">
                      Culinary Use
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-809">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-810" />{' '}
                      <span className="text-base" data-id="element-811">Alkaline-based</span>
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-812">
                      Regular
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-813">
                    <td className="p-4 text-base text-gray-900" data-id="element-814">
                      Coffee/Tea Extraction
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-815">
                      Superior
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-816">
                      Regular
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-817">
                    <td className="p-4 text-base text-gray-900" data-id="element-818">
                      No microplastics, forever chemicals, or fluoride
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-819">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-820" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-821">
                      <XIcon className="inline text-gray-400" size={20} data-id="element-822" />
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-823">
                    <td className="p-4 text-base text-gray-900" data-id="element-824">Ice Quality</td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-825">
                      Crystal-clear
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-826">
                      Regular
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-827">
                    <td className="p-4 text-base text-gray-900" data-id="element-828">
                      Menu Integration
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-829">
                      Alkaline
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-830">
                      Regular
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-831">
                    <td className="p-4 text-base text-gray-900" data-id="element-832">
                      Instant Near-Boiling Hot Water
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-833">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-834" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-835">
                      <XIcon className="inline text-gray-400" size={20} data-id="element-836" />
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-837">
                    <td className="p-4 text-base text-gray-900" data-id="element-838">
                      Unlimited Instant Sparkling Water
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-839">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-840" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-841">
                      <XIcon className="inline text-gray-400" size={20} data-id="element-842" />
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-843">
                    <td className="p-4 text-base text-gray-900" data-id="element-844">
                      Autofill Tech that Fills Bottles Hands-Free
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-845">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-846" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-847">
                      Some
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-848">
                    <td className="p-4 text-base text-gray-900" data-id="element-849">
                      No sitting water where bacteria or rust can form
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-850">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-851" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-852">
                      <XIcon className="inline text-gray-400" size={20} data-id="element-853" />
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-854">
                    <td className="p-4 text-base text-gray-900" data-id="element-855">Technology</td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-856">
                      AI + Auto-Clean
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-857">
                      Basic
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-858">
                    <td className="p-4 text-base text-gray-900" data-id="element-859">Lease Price</td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-860">
                      $299 USD / $399 CAD
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-861">
                      US$250–350/mo
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-862">
                    <td className="p-4 text-base text-gray-900" data-id="element-863">
                      Overall Value
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-864">
                      ⭐ Highest
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-865">
                      Regular
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Profit Calculator Section */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-866">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-867">
          <div className="max-w-6xl mx-auto" data-id="element-868">
            <RestaurantProfitCalculator data-id="element-869" />
          </div>
        </div>
      </div>

      {/* Optional Add-On — JuLi™ System */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-870">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-871">
          <div className="max-w-4xl mx-auto" data-id="element-872">
            <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl" data-id="element-873">
              <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-874">
                Optional Add-On — JuLi™ System
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-875">
                JuLi™ offers a complete beverage platform that pairs perfectly
                with WELLHAUS™:
              </p>

              <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-876">
                <div data-id="element-877">
                  <h3 className="text-xl font-medium mb-4" data-id="element-878">Features:</h3>
                  <ul className="space-y-3 text-gray-700 mb-6" data-id="element-879">
                    <li className="flex items-start gap-3" data-id="element-880">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-881" />
                      <span data-id="element-882">Alkaline Water</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-883">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-884" />
                      <span data-id="element-885">Sparkling Mineral Water</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-886">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-887" />
                      <span data-id="element-888">6 Flavors (soda, diet, juice, flavored water)</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-889">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-890" />
                      <span data-id="element-891">Smart micro-dosing</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-892">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-893" />
                      <span data-id="element-894">High-capacity cooling</span>
                    </li>
                  </ul>

                  <h3 className="text-xl font-medium mb-4" data-id="element-895">Ideal For:</h3>
                  <p className="text-gray-700 mb-4" data-id="element-896">
                    Flavored water, functional hydration, soda, and juice-style
                    beverages.
                  </p>
                  <p className="text-gray-700 font-medium" data-id="element-897">
                    Can be paired with WELLHAUS™ for a full hydration platform.
                  </p>
                </div>

                <div className="relative h-[400px] rounded-xl overflow-hidden shadow-lg" data-id="element-898">
                  <img src="https://cdn.magicpatterns.com/uploads/15ReUcFuSc8MYZsBEXiFai/JuLi™_System.webp" alt="JuLi System in elegant restaurant setting" className="w-full h-full object-cover" data-id="element-899" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="text-white py-20 md:py-32" style={{
      backgroundColor: '#1a2332'
    }} data-id="element-900">
        <div className="container mx-auto px-4 md:px-6 lg:px-12 text-center" data-id="element-901">
          <h2 className="text-4xl md:text-6xl font-light mb-6" data-id="element-902">
            Upgrade to the Most Advanced Water System on the Market
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-903">
            Only WELLHAUS offers Still, Sparkling, Alkaline, and Sparkling
            Mineral (Pellegrino-Style) water — plus custom bottles and full
            Section 179 benefits.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-904">
            <a href="https://form.typeform.com/to/rfYM00cT" target="_blank" rel="noopener noreferrer" className="px-10 py-4 bg-white text-gray-900 text-base font-medium rounded-full hover:bg-gray-100 transition-colors" data-id="element-905">
              Request a Demo
            </a>
            <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="px-10 py-4 border border-white text-white text-base font-medium rounded-full hover:bg-white hover:text-gray-900 transition-colors" data-id="element-906">
              Contact Sales
            </a>
          </div>
        </div>
      </div>
    </div>;
}